<template>
  <section
    v-if="isOpen"
    class="cookie-banner"
  >
    <div class="cookie-banner__inner">
      <v-info v-if="route === 'info'" />
      <v-settings v-else-if="route === 'settings'" />

      <div class="cookie-banner__links">
        <a href="/datenschutz/">Datenschutz</a>
        <a href="/impressum/">Impressum</a>
      </div>
    </div>
  </section>

  <button
    v-else
    class="button cookie-banner-button"
    aria-label="Cookie-Einstellungen"
    @click="open"
  >
    <svg
      viewBox="0 0 24 24"
      width="24"
      height="24"
      class="icon"
    >
      <path d="M12,3A9,9 0 0,0 3,12A9,9 0 0,0 12,21A9,9 0 0,0 21,12C21,11.5 20.96,11 20.87,10.5C20.6,10 20,10 20,10H18V9C18,8 17,8 17,8H15V7C15,6 14,6 14,6H13V4C13,3 12,3 12,3M9.5,6A1.5,1.5 0 0,1 11,7.5A1.5,1.5 0 0,1 9.5,9A1.5,1.5 0 0,1 8,7.5A1.5,1.5 0 0,1 9.5,6M6.5,10A1.5,1.5 0 0,1 8,11.5A1.5,1.5 0 0,1 6.5,13A1.5,1.5 0 0,1 5,11.5A1.5,1.5 0 0,1 6.5,10M11.5,11A1.5,1.5 0 0,1 13,12.5A1.5,1.5 0 0,1 11.5,14A1.5,1.5 0 0,1 10,12.5A1.5,1.5 0 0,1 11.5,11M16.5,13A1.5,1.5 0 0,1 18,14.5A1.5,1.5 0 0,1 16.5,16H16.5A1.5,1.5 0 0,1 15,14.5H15A1.5,1.5 0 0,1 16.5,13M11,16A1.5,1.5 0 0,1 12.5,17.5A1.5,1.5 0 0,1 11,19A1.5,1.5 0 0,1 9.5,17.5A1.5,1.5 0 0,1 11,16Z" />
    </svg>
  </button>
</template>

<script>
import VInfo from './views/VInfo.vue'
import VSettings from './views/VSettings.vue'

import { COOKIE_LIST } from './settings.js'
import { createFocusTrap } from 'focus-trap'
import { getCookie, setCookie } from './functions/cookie.js'
import EventBus from './functions/event-bus.js'

function initiallyOpen () {
  if (location.pathname === '/datenschutz/') {
    return false
  }

  if (location.pathname === '/impressum/') {
    return false
  }

  return !getCookie()
}

export default {
  name: 'VApp',

  components: {
    VInfo,
    VSettings
  },

  data () {
    return {
      route: 'info',
      focusTrap: null,
      isOpen: initiallyOpen()
    }
  },

  mounted () {
    EventBus.on('close', () => this.close())
    EventBus.on('route', name => { this.route = name })
    EventBus.on('accept-all', () => this.acceptAll())

    if (this.isOpen) {
      this.open()
    }
  },

  methods: {
    async open () {
      this.isOpen = true
      document.body.style.overflow = 'hidden'

      await this.$nextTick()

      this.focusTrap = createFocusTrap(this.$el, {
        escapeDeactivates: false,
        initialFocus: this.$el
      })

      this.focusTrap.activate()
    },
    close () {
      document.body.style.overflow = ''
      this.focusTrap.deactivate()
      this.isOpen = false
    },
    acceptAll () {
      const cookies = { ...COOKIE_LIST }

      for (const cookie in cookies) {
        cookies[cookie] = true
      }

      setCookie(cookies)
      EventBus.emit('close')
    }
  }
}
</script>
